import { render, staticRenderFns } from "./SidebarPreview.vue?vue&type=template&id=024144c4&scoped=true&"
import script from "./SidebarPreview.vue?vue&type=script&lang=js&"
export * from "./SidebarPreview.vue?vue&type=script&lang=js&"
import style0 from "./SidebarPreview.vue?vue&type=style&index=0&id=024144c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024144c4",
  null
  
)

export default component.exports